import React from 'react';
import PropTypes from 'prop-types';
import { Input as AntdInput } from 'antd';
import classNames from 'classnames';

import styles from './styles.scss';

const Input = ({ ...props }) => (
  <AntdInput
    {...props}
    className={classNames([styles.input, props.className])}
  />
);

Input.propTypes = {
  className: PropTypes.string,
};

export default Input;
